import { apiFetch } from '../api'
import type { AppSettings, BackupFile, CustomFormation, Lineup, Match, Opponent, Player, SetPiece, Tactic } from '../../types/domain'

export interface Repository<T extends { id: string }> {
  list(): Promise<T[]>
  get(id: string): Promise<T | undefined>
  save(record: T): Promise<string>
  remove(id: string): Promise<void>
}

class CloudRepository<T extends { id: string }> implements Repository<T> {
  constructor(private collection:string) {}
  list=()=>apiFetch<T[]>(`/api/data?collection=${encodeURIComponent(this.collection)}`)
  get=async(id:string)=>{try{return await apiFetch<T>(`/api/data?collection=${encodeURIComponent(this.collection)}&id=${encodeURIComponent(id)}`)}catch{return undefined}}
  save=async(record:T)=>{await apiFetch(`/api/data?collection=${encodeURIComponent(this.collection)}`,{method:'PUT',body:JSON.stringify(record)});return record.id}
  remove=async(id:string)=>{await apiFetch(`/api/data?collection=${encodeURIComponent(this.collection)}&id=${encodeURIComponent(id)}`,{method:'DELETE'})}
  clear=async()=>{await apiFetch(`/api/data?collection=${encodeURIComponent(this.collection)}&all=1`,{method:'DELETE'})}
}

export const playersRepository = new CloudRepository<Player>('players')
export const tacticsRepository = new CloudRepository<Tactic>('tactics')
export const lineupsRepository = new CloudRepository<Lineup>('lineups')
export const matchesRepository = new CloudRepository<Match>('matches')
export const opponentsRepository = new CloudRepository<Opponent>('opponents')
export const setPiecesRepository = new CloudRepository<SetPiece>('setPieces')
export const settingsRepository = new CloudRepository<AppSettings>('settings')
export const customFormationsRepository = new CloudRepository<CustomFormation>('customFormations')

const repositories=[playersRepository,tacticsRepository,lineupsRepository,matchesRepository,opponentsRepository,setPiecesRepository,settingsRepository,customFormationsRepository]

export async function exportBackup(): Promise<BackupFile> {
  const [players,tactics,lineups,matches,opponents,setPieces,settings,customFormations]=await Promise.all(repositories.map(repository=>repository.list())) as [Player[],Tactic[],Lineup[],Match[],Opponent[],SetPiece[],AppSettings[],CustomFormation[]]
  return {version:1,exportedAt:new Date().toISOString(),players,tactics,lineups,matches,opponents,setPieces,settings,customFormations}
}

export async function importBackup(backup: BackupFile) {
  if(backup.version!==1)throw new Error('Неподдерживаемая версия backup')
  await clearDatabase()
  await Promise.all([
    ...(backup.players??[]).map(record=>playersRepository.save(record)),...(backup.tactics??[]).map(record=>tacticsRepository.save(record)),
    ...(backup.lineups??[]).map(record=>lineupsRepository.save(record)),...(backup.matches??[]).map(record=>matchesRepository.save(record)),
    ...(backup.opponents??[]).map(record=>opponentsRepository.save(record)),...(backup.setPieces??[]).map(record=>setPiecesRepository.save(record)),
    ...(backup.settings??[]).map(record=>settingsRepository.save(record)),
    ...(backup.customFormations??[]).map(record=>customFormationsRepository.save(record)),
  ])
}

export async function clearDatabase(){await Promise.all(repositories.map(repository=>repository.clear()))}
